(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scb-cart-recommendations"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.scbCartRecommendationsLoaded) return;
    window.scbCartRecommendationsLoaded = true;
    const root = window.Shopify?.routes?.root || '/';
    const blocks = () => Array.from(document.querySelectorAll('[data-scb-recommendations]'));
    const render = cart => {
      blocks().forEach(block => {
        let count = 0;
        block.querySelectorAll('[data-scb-product]').forEach(card => {
          card.hidden = cart.item_count === 0 || count >= 2 || cart.items.some(item => String(item.product_id) === card.dataset.scbProduct);
          if (!card.hidden) count++;
        });
        block.hidden = count === 0;
      });
    };
    const refresh = async () => {
      try {
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin' });
        if (response.ok) render(await response.json());
      } catch (error) {}
    };
    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-scb-variant]');
      if (!button || button.disabled) return;
      event.preventDefault();
      const block = button.closest('[data-scb-recommendations]');
      const status = block.querySelector('[data-scb-status]');
      const messages = JSON.parse(block.querySelector('[data-scb-messages]').textContent);
      const buttons = blocks().flatMap(node => Array.from(node.querySelectorAll('[data-scb-variant]')));
      buttons.forEach(node => { node.disabled = true; });
      status.textContent = messages.adding;
      let added = false;
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.scbVariant), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || messages.error);
        added = true;
        if (!block.closest('#cartSlideoutWrapper') || !window.wetheme?.updateCartDrawer) {
          window.location.assign(root + 'cart');
          return;
        }
        const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin' });
        if (!cartResponse.ok) throw new Error(messages.error);
        const cart = await cartResponse.json();
        window.wetheme.updateCartDrawer(cart);
        render(cart);
        document.dispatchEvent(new CustomEvent('cart:added'));
        status.textContent = messages.added;
      } catch (error) {
        if (added) window.location.assign(root + 'cart');
        else status.textContent = error.message || messages.error;
      } finally {
        buttons.forEach(node => { node.disabled = false; });
      }
    });
    let timer;
    const scheduleRefresh = () => { clearTimeout(timer); timer = setTimeout(refresh, 150); };
    const initialize = () => {
      const list = document.querySelector('#cartSlideoutWrapper .cart-items');
      if (list) new MutationObserver(scheduleRefresh).observe(list, { childList: true });
      refresh();
    };
    document.addEventListener('cart:added', scheduleRefresh);
    document.addEventListener('shopify:section:load', scheduleRefresh);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
